import React, { useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import { ts, validatePhoneNumber } from "../utils/metaData";

export const ConnectForm = () => {
    const [data, setData] = useState({
        name: '',
        phone: '',
        email: '',
        message: '',
    })

    const handleChange = (e) => {
        const { name, value } = e.target;
        setData({
            ...data,
            [name]: value
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!data.name || !data.phone || !data.email || !data.message) {
            toast.error("All fields are required.");
            return;
        }

        if (!validatePhoneNumber(data.phone)) {
            toast.error("Invalid Phone Number");
            return;
        }

        try {
            const headers = {
                "Content-Type": "application/json",
                "pid": "INVST"
            }
            const body = JSON.stringify({
                meta: {
                    pid: "INVST",
                    appName: "investycoons",
                    ts: ts(),
                    reqAction: "connect",
                    location: "N/A",
                },
                pay: {
                    phone: data.phone,
                    name: data.name,
                    email: data.email,
                    message: data.message
                }
            })
            const response = await fetch(`${process.env.REACT_APP_BASEURL}/user/connect`, {
                method: "POST",
                body: body,
                headers: headers,
            })
            const res = await response.json()
            if (res.statusCode == '000') {
                toast.success(res.message)
            }
            else {
                toast.error(res.message)
            }
            setData({
                name: "",
                phone: "",
                email: "",
                message: ""
            })
        } catch (error) {
            toast.error("Something Went Wrong !");
        }
    }

    return (
        <div className="w-full md:w-1/3 p-4">
            <div className="py-1 sm:py-16 lg:py-4 relative bg-opacity-50 z-0">
                <h3 className="text-2xl font-semibold text-center text-black mb-4 mx-auto">
                    Send us a message
                </h3>
                <div className="flex justify-center items-center mt-2 my-12 mx-auto w-full">
                    <div className="flex flex-col w-full max-w-lg bg-gray-100 p-6 rounded-lg shadow-lg">
                        <form className="space-y-4 w-full" onSubmit={handleSubmit}>
                            <div>
                                <label htmlFor="name" className="block text-sm font-medium text-gray-700">Name</label>
                                <input
                                    type="text"
                                    name="name"
                                    id="name"
                                    placeholder="Name"
                                    autoComplete="given-name"
                                    value={data.name}
                                    onChange={handleChange}
                                    required
                                    className="mt-1 p-2 w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                                />
                            </div>

                            <div>
                                <label htmlFor="phone" className="block text-sm font-medium text-gray-700">Phone</label>
                                <input
                                    type="tel"
                                    name="phone"
                                    id="phone"
                                    placeholder="Phone Number"
                                    autoComplete="tel"
                                    value={data.phone}
                                    maxLength="10"
                                    onChange={handleChange}
                                    required
                                    className="mt-1 p-2 w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                                />
                            </div>

                            <div>
                                <label htmlFor="email" className="block text-sm font-medium text-gray-700">Email</label>
                                <input
                                    type="email"
                                    name="email"
                                    id="email"
                                    placeholder="Email"
                                    autoComplete="email"
                                    value={data.email}
                                    onChange={handleChange}
                                    required
                                    className="mt-1 p-2 w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                                />
                            </div>

                            <div>
                                <label htmlFor="message" className="block text-sm font-medium text-gray-700">Message</label>
                                <textarea
                                    id="message"
                                    name="message"
                                    placeholder="Message"
                                    rows="3"
                                    value={data.message}
                                    onChange={handleChange}
                                    required
                                    className="mt-1 p-2 w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                                ></textarea>
                            </div>

                            <div className="flex justify-center">
                                <button
                                    type="submit"
                                    className="w-full flex justify-center items-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-green-600 hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                                >
                                    Send
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <ToastContainer />
        </div>
    );
};
